import { render, staticRenderFns } from "./SaveButtons.vue?vue&type=template&id=71283604&scoped=true&"
import script from "./SaveButtons.vue?vue&type=script&setup=true&lang=js&"
export * from "./SaveButtons.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SaveButtons.vue?vue&type=style&index=0&id=71283604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71283604",
  null
  
)

export default component.exports